<template>
  <tr>
    <th nowrap>{{ label }}
      <div
        class="level-right"
        v-if="label == 'Asset Management'"
      >
        <b-input
          type="number"
          v-model="$store.state.longform.inputs.assetManagementPercent"
          @focus="$event.target.select()"
          @input="calculate()"
          size="is-small"
          style="width: 5em"
        ></b-input>%
      </div>
    </th>
    <td class="align-right">
      <LongFormDataCell
        :celldata=rowdata.monthYear1
        :percentDecimals=percentDecimals
      />
    </td>
    <td class="align-right">
      <LongFormDataCell
        :celldata="rowdata.monthYear2"
        :percentDecimals=percentDecimals
      />
    </td>
    <td class="align-right">
      <LongFormDataCell
        :celldata=rowdata.monthYear3
        :percentDecimals=percentDecimals
      />
    </td>
    <td class="align-right">
      <LongFormDataCell
        :celldata=rowdata.monthYear4
        :percentDecimals=percentDecimals
      />
    </td>
    <td class="align-right">
      <LongFormDataCell
        :celldata=rowdata.monthYear5
        :percentDecimals=percentDecimals
      />
    </td>
    <td class="align-right">
      <LongFormDataCell
        :celldata=rowdata.monthYear6
        :percentDecimals=percentDecimals
      />
    </td>
    <td class="align-right">
      <LongFormDataCell
        :celldata=rowdata.monthYear7
        :percentDecimals=percentDecimals
      />
    </td>
    <td class="align-right">
      <LongFormDataCell
        :celldata=rowdata.monthYear8
        :percentDecimals=percentDecimals
      />
    </td>
    <td class="align-right">
      <LongFormDataCell
        :celldata=rowdata.monthYear9
        :percentDecimals=percentDecimals
      />
    </td>
    <td class="align-right">
      <LongFormDataCell
        :celldata=rowdata.monthYear10
        :percentDecimals=percentDecimals
      />
    </td>
    <td class="align-right">
      <LongFormDataCell
        :celldata=rowdata.monthYear11
        :percentDecimals=percentDecimals
      />
    </td>
    <td class="align-right">
      <LongFormDataCell
        :celldata=rowdata.monthYear12
        :percentDecimals=percentDecimals
      />
    </td>
    <th>
      <LongFormDataCell
        :celldata=rowdata.annual
        :percentDecimals=percentDecimals
      />
    </th>
    <td class="align-right">
      <LongFormDataCell
        :celldata=rowdata.perUnit
        :percentDecimals=percentDecimals
      />
    </td>
    <td class="align-right">
      <LongFormDataCell
        :celldata=rowdata.percentGpr
        :percentDecimals=percentDecimals
      />
    </td>
    <td
      class="align-right"
      style="border-right: 2px solid #000;"
    >
      <LongFormDataCell
        :celldata=rowdata.percentNaaSurvey
        :percentDecimals=percentDecimals
      />
    </td>
    <td class="align-right">
      <LongFormDataCell
        :celldata=rowdata.year2
        :percentDecimals=percentDecimals
      />
    </td>
    <td class="align-right">
      <LongFormDataCell
        :celldata=rowdata.year3
        :percentDecimals=percentDecimals
      />
    </td>
    <td class="align-right">
      <LongFormDataCell
        :celldata=rowdata.year4
        :percentDecimals=percentDecimals
      />
    </td>
    <td class="align-right">
      <LongFormDataCell
        :celldata=rowdata.year5
        :percentDecimals=percentDecimals
      />
    </td>
    <td class="align-right">
      <LongFormDataCell
        :celldata=rowdata.year6
        :percentDecimals=percentDecimals
      />
    </td>
  </tr>
</template>

<script>
import LongFormDataCell from "@/components/properties/evaluations/multifamily/LongFormDataCell.vue";

export default {
  components: {
    LongFormDataCell
  },

  props: {
    rowdata: {
      type: Object
    },
    label: {
      type: String
    },
    percentDecimals: {
      type: Number,
      default: 2
    }
  },

  data() {
    return {};
  },

  methods: {
    calculate() {
      this.$parent.calculate();
    }
  },

  mounted() {}
};
</script>

<style>
</style>
